import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { passwordResetLink, clickForgotPassword } from '../../actions/auth';
import Loader from '../loader/Loader';

import ecom_logo_color from '../../img/ecom_logo_color.png';
import forgot_password_icon from '../../img/forgot_password_icon.png';
import checkyouremail_logo from '../../img/check_email.png';

import '../../css/onBoarding/forgotpassword.css';
import '../../css/onBoarding/checkyouremail.css';

const ForgotPassword = ({
  passwordResetLink,
  isAuthenticated,
  isResetLinkSent,
  msg,
  clickForgotPassword,
}) => {
  const [formData, setFormData] = useState({
    email: '',
  });

  const [loading, setLoading] = useState(false);
  const [isButtonClicked, setIsButtonClicked] = useState(false); // New state variable

  useEffect(() => {
    document.body.classList.add('with-background-4');

    return () => {
      document.body.classList.remove('with-background-4');
    };
  }, []);

  // Destructure formData
  const { email } = formData;

  const navigate = useNavigate();

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Reset the button's disabled state
    setIsButtonClicked(false);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setIsButtonClicked(true); // Set the button as clicked
    passwordResetLink(email)
      .then((e) => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    // console.log('Success');
  };

  const handleClickForgotPassword = async (e) => {
    e.preventDefault();

    // console.log('click on event');

    // Call action here
    await clickForgotPassword();
    // console.log('below action function');

    //navigate to link page
    navigate('/email-forgot-password');
    // console.log('below navigate');
  };

  // Redirect if logged in
  // if (isAuthenticated) {
  //   return <Navigate to='/dashboard' />;
  // }

  const loginPage = (e) => {
    e.preventDefault();
    <Navigate to='/login' />;
  };

  const checkYourEmail = (
    <div className='flex flex-col items-center justify-center text-center p-4'>
      {/* Logo */}
      <img
        src={checkyouremail_logo}
        alt='Check your email logo'
        className='w-20 h-20 mb-3'
      />
      {/* Heading */}
      <h2 className='forgot-pass-heading mb-2.5'>Check Your Email</h2>
      {/* Description */}
      <p className='forgot-pass-sub-heading mb-4'>
        Please check your email inbox to reset <br /> the password.
      </p>
      {/* Resend Link */}
      <Link
        to='/email-forgot-password'
        className='forgot-pass-resend-link-btn mt-1 w-full py-2 px-4 transition'
        onClick={handleClickForgotPassword}
      >
        Resend
      </Link>
    </div>
  );

  const sendEmail = (
    <div className='flex flex-col items-center justify-center text-center p-4'>
      {/* Heading */}
      <h2 className='forgot-pass-heading'>Reset Your Password</h2>
      <p className='forgot-pass-sub-heading'>
        Enter your registered email address below to <br /> receive a link to
        reset your password.
      </p>
      {/* Form */}
      <form className='w-full max-w-sm' onSubmit={onSubmit} method='POST'>
        <input
          id='email-address'
          name='email'
          type='email'
          value={email}
          onChange={onChange}
          autoComplete='email'
          required
          placeholder='Email'
          className='forgot-pass-email-input w-full p-2'
        />
        <button
          type='submit'
          className={`forgot-pass-continue-button w-full py-2 transition ${
            isButtonClicked ? 'opacity-50 cursor-not-allowed' : ''
          }`}
          disabled={isButtonClicked}
        >
          Continue
        </button>
      </form>
      {/* Back to Login */}
      <Link
        to='/login'
        className='forgot-pass-login-link text-blue-500 hover:underline transition'
      >
        Back to Login
      </Link>
    </div>
  );

  return (
    <div className='min-h-screen flex flex-col'>
      {/* Top Section: Logo */}
      <div className='flex items-center justify-center px-4 pt-10 pb-4'>
        <Link to='/login'>
          <img
            src={ecom_logo_color}
            alt='Logo'
            className='forgot-pass-page-logo'
          />
        </Link>
      </div>

      {/* Middle Section: Content */}
      <div className='flex-1 flex items-center justify-center'>
        {!isResetLinkSent ? sendEmail : checkYourEmail}
      </div>
    </div>
  );
};

ForgotPassword.propTypes = {
  setAlert: PropTypes.func.isRequired,
  passwordResetLink: PropTypes.func.isRequired,
  // isAuthenticated: PropTypes.bool.isRequired,
  isResetLinkSent: PropTypes.bool.isRequired,
  // msg: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  isResetLinkSent: state.auth.isResetLinkSent,
  msg: state.auth.msg,
});

export default connect(mapStateToProps, {
  passwordResetLink,
  clickForgotPassword,
})(ForgotPassword);
